export * from './FractionalOwnershipInquiryCard'
